export default "__VITE_ASSET__DER1uIb4__"